import React, { useId } from 'react';
import { AppIcon } from '../../../../components/icons/AppIcon';
import { FunnelStage, Lead, CrmUser } from '../../../../types';
import { DealCard } from './DealCard';

interface ContactPanelDealsProps {
    isOpen: boolean;
    onToggle: () => void;
    currentLeads: Lead[];
    onCreateDeal: () => void;
    isCreatingDeal?: boolean;
    funnelStages: FunnelStage[];
    crmUsers: CrmUser[];
    onStageChange: (leadId: string, stageId: string) => void;
    onLeadUpdate: (lead: Lead) => void;
}

export const ContactPanelDeals: React.FC<ContactPanelDealsProps> = ({
    isOpen,
    onToggle,
    currentLeads,
    onCreateDeal,
    isCreatingDeal = false,
    funnelStages,
    crmUsers,
    onStageChange,
    onLeadUpdate
}) => {
    const panelId = useId();

    return (
        <section>
            <button
                type="button"
                onClick={onToggle}
                className="flex min-h-11 w-full items-center justify-between px-3 py-2"
                aria-expanded={isOpen}
                aria-controls={panelId}
            >
                <div className="flex items-center gap-2 chat-section-heading">
                    <span>Negociações</span>
                    <span className="chat-count rounded-full border border-border bg-surface-subtle px-1.5 py-0 leading-5 text-muted">
                        {currentLeads.length}
                    </span>
                </div>
                <AppIcon
                    name="chevron-down"
                    className={`chat-accordion-chevron ${isOpen ? '' : 'chat-accordion-chevron--closed'}`}
                    aria-hidden="true"
                />
            </button>
            {isOpen && (
                <div id={panelId} className="bg-card px-3 pb-3">
                    {currentLeads.length > 0 ? (
                        <ul className="mb-1 list-none space-y-2 p-0">
                            {currentLeads.map(lead => (
                                <li key={lead.id}>
                                    <DealCard
                                        lead={lead}
                                        funnelStages={funnelStages}
                                        crmUsers={crmUsers}
                                        onStageChange={onStageChange}
                                        onLeadUpdate={onLeadUpdate}
                                    />
                                </li>
                            ))}
                        </ul>
                    ) : null}
                    <button
                        type="button"
                        onClick={onCreateDeal}
                        disabled={isCreatingDeal}
                        className={
                            currentLeads.length === 0
                                ? 'chip chip--dashed min-h-11 w-full max-w-full justify-center rounded-lg px-3'
                                : 'chip chip--dashed mt-1 min-h-11 w-full max-w-full justify-center rounded-lg px-3'
                        }
                    >
                        <AppIcon name="plus" className="size-4 shrink-0" aria-hidden="true" />
                        <span className="min-w-0 truncate">{isCreatingDeal ? 'Criando negociação...' : 'Criar uma negociação'}</span>
                    </button>
                </div>
            )}
        </section>
    );
};
